import { getTimezoneDate, normalizeTimezone } from '@cvo/domain';
import { format } from 'date-fns/format';
import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { useI18n } from '@cvo/i18n/composables/useI18n';

export function useTimezoneDate(date: MaybeRefOrGetter<Date>, timezone: MaybeRefOrGetter<string>) {
  const { t } = useI18n();
  const tzDate = computed(() => {
    return getTimezoneDate(toValue(date), normalizeTimezone(toValue(timezone)));
  });

  const stationLocalDate = computed(() => {
    return format(tzDate.value, t('ui.date.formats.longDate'));
  });

  const stationLocalTime = computed(() => {
    return format(tzDate.value, t('ui.date.formats.hourMinutes'));
  });

  const stationTimezoneName = computed(() => {
    return format(tzDate.value, 'O');
  });

  const userLocalDateTime = computed(() => {
    return format(toValue(date), `${t('ui.date.formats.longDate')} ${t('ui.date.formats.hourMinutes')}`);
  });

  return {
    tzDate,
    stationLocalDate,
    stationLocalTime,
    stationTimezoneName,
    userLocalDateTime,
  };
}